import humps from 'humps'

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$humps', { value: humps })
  },
}
